module.exports = __webpack_public_path__ + "img/icon0.49ea4a1b.svg";